
<v-data-table
  v-bind="$props"
  :headers="extendedHeaders"
  :items-per-page="itemsPerPage"
  :item-class="extendedItemClass"
  dense
  :disable-sort="disableSort"
  :class="interactable ? 'cassie-table' : 'cassie-table--no-hover'"
  no-data-text="No data available"
  fixed-header
  :height="defaultHeight"
  @current-items="$emit('current-items', $event)"
  v-on="$listeners"
>
  <template #item.selected-column="{ item: row }">
    <v-icon :color="rowSelected(row) ? 'info' : ''">
      {{ rowSelected(row) ?
        multiSelect ? '$checkboxOn' : 'mdi-radiobox-marked' :
        multiSelect ? '$checkboxOff': 'mdi-radiobox-blank'
      }}
    </v-icon>
  </template>
  <template
    v-for="slot in slots"
    #[slot]="props"
  >
    <slot
      :name="slot"
      v-bind="props"
    />
  </template>
</v-data-table>
